module.exports = __webpack_public_path__ + "img/title2.db297d9.webp";